import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Particle from '../Particle';
import Tech from './Tech';
import aboutLogo from '../../assets/aboutLogo.svg';
import corelDraw from '../../assets/corelDraw.svg';
import sonyVegas from '../../assets/sonyVegas.svg';

function About(props) {
	let english = {
		"knowwho": "Know Who",
		"iam": "I am",
		"blockquote1": "Hi Everyone, I am",
		"blockquote2": "from",
		"blockquote3": "Bydgoszcz in Poland.",
		"blockquote4": "I am a junior trying to become a professional",
		"blockquote5": "front-end developer.",
		"blockquote6": "This portfolio is one of my projects",
		"blockquote7": "In addition to coding, these are some other activities that I love to do!",
		"activity1": "Playing Games",
		"activity2": "Graphic Design",
		"activity3": "Video Editing",
		"activity4": "Reading SF Books",
		"tech_main1": "Technologies ",
		"tech_main2": "I mainly use",
		"tech_main3": "I choose a technologies set depending on project I'm currently doing.",
		"tech_less1": "Technologies ",
		"tech_less2": "I know a bit less",
		"tech_less3": "But I have used them in some old projects.",
		"tools_programming1": "Tools ",
		"tools_programming2": "I use for",
		"tools_programming3": "programming",
		"tools_graphic1": "Tools ",
		"tools_graphic2": "I use for",
		"tools_graphic3": "graphic design",
		"tools_graphic4": "or",
		"tools_graphic5": "video editing"
	};

	let polish = {
		"knowwho": "Poznaj",
		"iam": "Mnie",
		"blockquote1": "Witaj, nazywam się",
		"blockquote2": "i mieszkam w",
		"blockquote3": "Bydgoszczy, w Polsce.",
		"blockquote4": "Jestem początkującym, który stara się zostać profesjonalnym",
		"blockquote5": "programistą Front-end.",
		"blockquote6": "To portfolio jest jednym z moich projektów",
		"blockquote7": "Poza programowaniem jest kilka innych rzeczy, które uwielbiam robić!",
		"activity1": "Gry komputerowe",
		"activity2": "Grafika komputerowa",
		"activity3": "Montaż filmów",
		"activity4": "Czytanie książek SF",
		"tech_main1": "Technologie",
		"tech_main2": ", które głównie używam",
		"tech_main3": "Wybieram odpowiedni zestaw technologii w zależności od aktualnego projektu.",
		"tech_less1": "Technologie",
		"tech_less2": ", które znam trochę mniej",
		"tech_less3": "Ale używałem ich w starszych projektach.",
		"tools_programming1": "Narzędzia",
		"tools_programming2": ", których używam do",
		"tools_programming3": "programowania",
		"tools_graphic1": "Narzędzia",
		"tools_graphic2": ", których używam do",
		"tools_graphic3": "tworzenia grafiki",
		"tools_graphic4": "lub",
		"tools_graphic5": "montażu filmów"
	};

	let language = '';
	if (props.language === 'english') {
		language = english;
	} else {
		language = polish;
	}

	return (
		<Container fluid className='about-section'>
			<Particle />
			<Container>
				<Row style={{ justifyContent: 'center', padding: '10px' }}>
					<Col md={7} style={{ justifyContent: 'center', paddingTop: '30px', paddingBottom: '50px' }}>
						<h1 style={{ fontSize: '2.1em', paddingBottom: '20px' }}>
							{language.knowwho} <strong className='color2'>{language.iam}</strong>
						</h1>
						<Card className='quote-card-view'>
							<Card.Body>
								<blockquote className='blockquote mb-0'>
									<p style={{ textAlign: 'justify' }}>
										{language.blockquote1} <span className='color2'>Robert Buritta</span> {language.blockquote2}
										<span className='color2'> {language.blockquote3}</span>
										&nbsp;{language.blockquote4}
										<span className='color2'> {language.blockquote5} </span>
										{language.blockquote6} <i className="far fa-smile-beam" style={{ fontSize: '22px' }}></i>.
										<br /><br />
										{language.blockquote7}
									</p>
									<ul>
										<li className='about-activity'>
											<i className='far fa-hand-point-right'></i> {language.activity1}
										</li>
										<li className='about-activity'>
											<i className='far fa-hand-point-right'></i> {language.activity2}
										</li>
										<li className='about-activity'>
											<i className='far fa-hand-point-right'></i> {language.activity3}
										</li>
										<li className='about-activity'>
											<i className='far fa-hand-point-right'></i> {language.activity4}
										</li>
									</ul>
								</blockquote>
							</Card.Body>
						</Card>
					</Col>
					<Col md={5} style={{ paddingTop: '30px', paddingBottom: '120px' }} className='about-img'>
						<img src={aboutLogo} alt='about' className='img-fluid' />
					</Col>
				</Row>
				<h1 className='project-heading'>
					<strong className='color2'>{language.tech_main1}</strong>{language.tech_main2}
				</h1>
				<p>{language.tech_main3}</p>
				<Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
					<Tech iconName='devicon-html5-plain-wordmark' />
					<Tech iconName='devicon-css3-plain-wordmark' />
					<Tech iconName='devicon-bootstrap-plain-wordmark' />
					<Tech iconName='devicon-javascript-plain' />
					<Tech iconName='devicon-jquery-plain-wordmark' />
					<Tech iconName='devicon-git-plain-wordmark' />
					<Tech iconName='devicon-react-original-wordmark' />
					<Tech iconName='devicon-nodejs-plain-wordmark ' />
					<Tech iconName='devicon-express-original-wordmark' />
					<Tech iconName='devicon-mongodb-plain-wordmark' />
					<Tech iconName='devicon-firebase-plain-wordmark' />
				</Row>
				<h1 className='project-heading'>
					<strong className='color2'>{language.tech_less1}</strong>{language.tech_less2}
				</h1>
				<p>{language.tech_less3}</p>
				<Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
					<Tech iconName='devicon-python-plain-wordmark' />
					<Tech iconName='devicon-csharp-plain-wordmark' />
					<Tech iconName='devicon-java-plain-wordmark' />
					<Tech iconName='devicon-wordpress-plain-wordmark' />
					<Tech iconName='devicon-php-plain' />
					<Tech iconName='devicon-symfony-original-wordmark' />
					<Tech iconName='devicon-mysql-plain-wordmark' />
				</Row>
				<h1 className='project-heading'>
					<strong className='color2'>{language.tools_programming1}</strong>{language.tools_programming2}
					<strong className='color2'> {language.tools_programming3}</strong>
				</h1>
				<Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
					<Tech iconName='cib-windows' />
					<Tech iconName='cib-visual-studio-code' />
					<Tech iconName='cib-visual-studio' />
					<Tech iconName='cib-postman' />
				</Row>
				<h1 className='project-heading'>
					<strong className='color2'>{language.tools_graphic1}</strong>{language.tools_graphic2}
					<strong className='color2'> {language.tools_graphic3}</strong>
					<br />{language.tools_graphic4} <strong className='color2'>{language.tools_graphic5}</strong>
				</h1>
				<Row style={{ justifyContent: 'center' }}>
					<Col xs={4} md={2} className='tech-icons' style={{ maxWidth: '100px' }}>
						<img src={corelDraw} alt='Corel Draw' height='118' />
					</Col>
					<Tech iconName='devicon-photoshop-plain' />
					<Tech iconName='devicon-illustrator-plain' />
				</Row>
				<Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
					<Col xs={4} md={2} className='tech-icons' style={{ maxWidth: '150px', padding: '2px 0 8px 0' }}>
						<img src={sonyVegas} alt='Sony Vegas' height='80' />
					</Col>
					<Tech iconName='devicon-premierepro-plain' />
					<Tech iconName='devicon-aftereffects-plain' />
				</Row>
			</Container>
		</Container>
	);
}

export default About;
